export default __webpack_public_path__ + "cover.3cdcda40fec3a16399fad6b2186536b2.jpg"